import * as Widget from './base';
import * as WidgetHelper from './helper';

function widget_trigger(config) {
  return Widget.get(config).querySelector(`.driftrock-launcher-trigger`);
}

function widget_content(config) {
  return Widget.get(config).querySelector(`.driftrock-launcher`);
}

function setup_trigger(config) {
  var launcher = Widget.get(config);

  if (launcher) {
    var trigger_button = launcher.querySelector(`.driftrock-launcher-trigger__cta`);

    if (trigger_button) {
      trigger_button.addEventListener('click', function (e) {
        toggle_content(config)
      });
    }
  }
}

function is_widget_content_visible(config) {
  var launcher_content = widget_content(config);

  if (launcher_content) {
    return !launcher_content.classList.contains('invisible')
  }
}

function show_content(config) {
  var launcher_content = widget_content(config);

  if (launcher_content) {
    launcher_content.classList.remove('invisible');

    WidgetHelper.sync_iframe_height(launcher_content);
  }
}

function hide_content(config) {
  var launcher_content = widget_content(config);

  if (launcher_content) {
    launcher_content.classList.add('invisible');
  }
}

function toggle_content(config) {
  var launcher_content = widget_content(config);

  if (launcher_content) {
    if (is_widget_content_visible(config)) {
      hide_content(config);
    } else {
      show_content(config);
    }
  }
}

export function show(config) {
  var launcher = Widget.get(config);

  if (launcher) {
    launcher.classList.remove('invisible');
  }
}

export function hide(config) {
  var launcher = Widget.get(config);

  if (launcher) {
    launcher.classList.add('invisible');
  }
}

export function toggle(config) {
  Widget.toggle(config);
}

export function init(config) {
  if (Driftrock.settings.debug) {
    console.info(`[Driftrock] Initialising launcher widget: ${config.widget.id}`);
  }

  if (config.widget_html) {
    document.body.insertAdjacentHTML('beforeend', config.widget_html)

    Widget.init_content(config);

    WidgetHelper.setup_open(config, show);

    setup_trigger(config);
  }
}
